import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { BASE_URL } from "./constants";

export const notificationApi = createApi({
  reducerPath: "notification/api",
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
    prepareHeaders: (headers, { getState }) => {
      const { token } = getState().users;
      headers.set("Content-Type", "application/json");
      headers.set("Authorization", `Bearer ${token}`);
      return headers;
    },
  }),
  endpoints: (build) => ({
    getNotifications: build.query({
      query: ({ pageNumber, notificationTypes = [], filters = "" }) => ({
        url: `api/notifications/get-user-notifications-disp?pageNumber=${pageNumber}${notificationTypes
          .map((type) => `&notificationTypes=${type}`)
          .join("")}${filters}`,
      }),
    }),
    getNotificationsCount: build.query({
      query: ({
        getUnreadMessages = true,
        lastReceivedMessageTime = "",
        notificationTypes = [],
        filters = "",
      }) => ({
        url: `api/notifications/get-user-notifications-disp-count?getUnreadMessages=${getUnreadMessages}&lastReceivedMessageTime=${lastReceivedMessageTime}&isProcessedMessages=false${notificationTypes
          .map((type) => `&notificationTypes=${type}`)
          .join("")}${filters}`,
      }),
    }),
    markNotificationAsRead: build.mutation({
      query: (data) => ({
        url: "api/notifications/mark-notification-as-read",
        method: "PUT",
        body: data,
      }),
    }),
  }),
});

export const {
  useMarkNotificationAsReadMutation,
  useLazyGetNotificationsCountQuery,
  useLazyGetNotificationsQuery,
} = notificationApi;
